import React from 'react';
import {
  styled,
  Typography as MuiTypography,
  type TypographyProps as MuiTypographyProps,
  Skeleton,
} from '@mui/material';

export const dataTestId = {
  skeleton: 'TypographySkeleton',
};

const MinWidthSkeleton = styled(Skeleton)`
  min-width: 5rem;
`;

export interface TypographyProps extends MuiTypographyProps {
  // eslint-disable-next-line react/no-unused-prop-types
  loading?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  component?: React.ElementType;
}

const Typography: React.FC<TypographyProps> = React.memo(
  React.forwardRef<HTMLElement, TypographyProps>(function Typography(
    { loading, children, ...props }: TypographyProps,
    ref,
  ) {
    return (
      <MuiTypography {...props} ref={ref}>
        {loading ? <MinWidthSkeleton data-testid={dataTestId.skeleton} variant="rounded" /> : children}
      </MuiTypography>
    );
  }),
);

export default Typography;
